import React, { useContext, useState } from 'react';
import { date_icon, slot_icon } from '../../../../utils/images';
import { ClientContext } from '../../../Contexts/contexts';
import { firstDateAfterSecondDate, formatDate } from '../../../../utils/date';
import { useNavigate } from 'react-router-dom';

function QuoteElementUserRdvModal(props) {
  const clientContext = useContext(ClientContext);

  const [showModal, setShowModal] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState(null);

  const navigate = useNavigate();

  function getAppointments() {
    const result = clientContext?.appointments.filter(
      (item) => item?.clientExpertRelationshipId === props?.data?.id
    );

    result.sort((appointment1, appointment2) => {
      if (
        firstDateAfterSecondDate(
          appointment1.appointmentDate,
          appointment2.appointmentDate
        )
      )
        return 1;
      else return -1;
    });

    return result || [];
  }

  async function validateModal() {
    if (selectedAppointment === null) return;

    setShowModal(false);

    clientContext.selectAppointment(selectedAppointment, () => {
      navigate('/accepted-quotes');
    });
  }

  function closeModal(e) {
    e.stopPropagation();
    setShowModal(false);
  }

  return (
    <>
      <div
        className="element-button pending-status"
        onClick={() => setShowModal(true)}
      >
        Voir les dates de rendez-vous
      </div>
      {showModal && (
        <div className="container-rdv-modal">
          <div
            className="background-rdv-modal"
            onClick={(e) => closeModal(e)}
          ></div>
          <div className="modal-rdv accepted-rdv-modal">
            <div className="modal-rdv-title">Proposition de rendez-vous</div>
            <div className="user-rdv-list">
              {getAppointments().map((rdv, index) => (
                <div className="user-rdv-detail" key={rdv.id}>
                  <div className="user-rdv-input">
                    <input
                      type="radio"
                      id={rdv.id}
                      name="rdv"
                      value=""
                      className="rdv-input"
                      onClick={() => setSelectedAppointment(rdv)}
                    />
                    <label
                      className="rdv-label"
                      htmlFor={rdv.id}
                    >{`Rendez-vous ${index + 1}`}</label>
                  </div>
                  <span className="rdv-date">
                    <img
                      src={date_icon}
                      alt="date icon"
                      className="rdv-date-icon"
                    />
                    {formatDate(rdv.appointmentDate, 'DD.MM.YYYY')}
                  </span>
                  <span className="rdv-slot">
                    <img
                      src={slot_icon}
                      alt="date icon"
                      className="rdv-slot-icon"
                    />
                    {formatDate(rdv.appointmentDate, 'HH:mm')}
                  </span>
                </div>
              ))}
              <div className="user-rdv-detail rdv-no-good-date" key="no-date">
                <div className="user-rdv-input">
                  <input
                    type="radio"
                    id="no-rdv"
                    name="rdv"
                    value=""
                    className="rdv-input"
                    onClick={() => setSelectedAppointment(-1)}
                  />
                  <label className="rdv-label" htmlFor="no-rdv">
                    Aucune date ne me convient
                  </label>
                </div>
              </div>
            </div>
            <div className="choose-rdv" onClick={() => validateModal()}>
              Confirmer date rendez-vous
            </div>
            <div
              className="cancel-rdv-modal"
              onClick={() => setShowModal(false)}
            >
              Annuler
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default QuoteElementUserRdvModal;
